export const jobTypes = [
	{ label: "Full Time", value: "Full Time" },
	{ label: "Part Time", value: "Part Time" },
	{ label: "Contract", value: "Contract" },
	{ label: "Intern", value: "Intern" },
	{ label: "Remote", value: "Remote" },
];
